import { Alert, Button } from '@mui/material';
import { useState } from 'react';
import RenewSubscriptionModal from './RenewSubscriptionModal';

export default function ExpiringBanner({ expired, days, expiresAtLabel, appName, appKey }) {
  const [open, setOpen] = useState(false);

  const expiringMessage = expiresAtLabel
    ? `Tu suscripción vence en ${days} día${days === 1 ? '' : 's'} (${expiresAtLabel}).`
    : `Tu suscripción vence en ${days} día${days === 1 ? '' : 's'}.`;

  const expiredMessage = expiresAtLabel
    ? `Tu suscripción venció el ${expiresAtLabel}. Renueva para continuar.`
    : 'Tu suscripción venció. Renueva para continuar.';

  return (
    <>
      <Alert
        severity={expired ? 'error' : 'warning'}
        action={
          expired && (
            <Button
              color="inherit"
              size="small"
              onClick={() => setOpen(true)}
            >
              Renovar
            </Button>
          )
        }
        sx={{ mb: 2 }}
      >
        {expired ? expiredMessage : expiringMessage}
      </Alert>

      <RenewSubscriptionModal
        open={open}
        onClose={() => setOpen(false)}
        appName={appName}
        appKey={appKey}
      />
    </>
  );
}
